export const env = process.env.REACT_APP_ENV;

const localHost = process.env.REACT_APP_LOCAL_HOST;
const websocketBase = process.env.REACT_APP_WEBSOCKET_BASE;

const host =
  env === "development"
    ? "api.dev.mrkt365.com"
    : "api.mrkt365.com";

const HOST_URL = `https://${host}/`;

export const CURRENT_URL = `${env === "development" ? "http" : "https"}://${window.location.host}/`;

export const PLATFORM_URL = `${env === "development" ? "http" : "https"}://${
  env === "production"
    ? process.env.REACT_APP_PLATFORM_PROD_URL
    : process.env.REACT_APP_PLATFORM_QA_URL
}/`;

// Endpoints
export const userEndpoint = env === "development"
  ? `${localHost}mrkt365user/api/v1/`
  : `${HOST_URL}mrkt365user/api/v1/`;

export const vendorEndpoint = env === "development"
  ? `${localHost}mrkt365vendor/api/v1/`
  : `${HOST_URL}mrkt365vendor/api/v1/`;

export const projectEndpoint = env === "development"
  ? `${localHost}mrkt365project/api/v1/`
  : `${HOST_URL}mrkt365project/api/v1/`;

export const paymentEndpoint = env === "development"
  ? `${localHost}mrkt365payment/api/v1/`
  : `${HOST_URL}mrkt365payment/api/v1/`;

export const superAdminEndpoint = env === "development"
  ? `${localHost}mrkt365superadmin/api/v1/`
  : `${HOST_URL}mrkt365superadmin/api/v1/`;

// WebSocket
export const taskChatWebsockerUrl = `wss://${websocketBase}/ws/chat/`;

export const trueProductionFlag = env === "production";

export const ClientToken = process.env.REACT_APP_CLIENT_TOKEN;
